// extracted by mini-css-extract-plugin
module.exports = {"error":"Paypal_error__2GxED"};